import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { useState } from 'react';
import { useMenuState } from './useMenuState.js';
const useMenuStateAndFocus = options => {
  const [menuProps, toggleMenu] = useMenuState(options);
  const [menuItemFocus, setMenuItemFocus] = useState();
  const openMenu = (position, alwaysUpdate) => {
    setMenuItemFocus({
      position,
      alwaysUpdate
    });
    toggleMenu(true);
  };
  return [_objectSpread({
    menuItemFocus
  }, menuProps), toggleMenu, openMenu];
};
export { useMenuStateAndFocus };